import * as React from 'react'
import { Link } from "gatsby"

export const buttonVariants = {
  "button-text": "uppercase font-martel-sans font-semibold leading-[normal] text-[16px] md:text-[16px] tracking-[1.44px]",
  "primary-button": "inline-block border bg-black border-[1px] text-white text-[16px] leading-[normal] rounded-[32px] cursor-pointer min-w-full max-w-full px-5 py-2.5 text-center hover:bg-white hover:text-black focus:border-white md:min-w-[363px] md:py-4",
  "primary-button-sky": "inline-block border border-[1px] text-[16px] leading-[normal] rounded-[32px] cursor-pointer min-w-full max-w-full px-5 py-2.5 text-center md:min-w-[219px] md:py-4 bg-sky text-black border-sky hover:bg-transparent",
  "square-button": "inline-block bg-black border-solid text-white text-[16px] leading-[normal] cursor-pointer min-w-full max-w-[167px] p-10 text-center hover:text-black hover:bg-white focus:border-white md:py-4",
  "secondary-button": "relative inline-block text-black text-[16px] leading-[normal] cursor-pointer before:absolute before:block before:bg-black before:bottom-[-5px] before:h-px before:w-full after:absolute after:block after:bg-black after:bottom-[-5px] after:h-px after:w-0 after:transition-[width] after:duration-500 after:ease-linear hover:border-none hover:before:hidden hover:after:h-px hover:after:w-full"
}


type ButtonVariant = keyof typeof buttonVariants
interface OwnProps {
  classNames?: string;
  text: string;
  to?: string;
  href?: string;
  variant: ButtonVariant;
  onClick?: (e: React.MouseEvent) => void;
}

export type ButtonProps = OwnProps

export const Button: React.FC<ButtonProps> = ({
  classNames,
  text,
  variant,
  href,
  to,
  ...props
}) => {
  if (to) {
    return <Link className={`${buttonVariants["button-text"]} ${buttonVariants[variant]} ${classNames}`} to={to} {...props}>{text}</Link>
  } else if(href) {
    return <a className={`${buttonVariants["button-text"]} ${buttonVariants[variant]} ${classNames}`} href={href} {...props}>{text}</a>;
  } else {
    return <button className={`${buttonVariants["button-text"]} ${buttonVariants[variant]} ${classNames}`} {...props}>{text}</button>;
  }
}
